import { connect } from 'react-redux';
import React from 'react';
import moment from 'moment';
import nl2br from 'react-nl2br';
import { emojify } from 'react-emojione';
import Linkify from'react-linkify';

import Reply from 'components/RepliesList/Reply';
import * as actions from 'actions';
import { MailThreadMessageShape } from 'entities';

export const MailThreadMessage = props => {
  const { mailThreadMessage } = props;

  return (
    <Reply
      threadMessageId={mailThreadMessage.id}
             isUnread={!mailThreadMessage.read}
     isFromCounsellor={mailThreadMessage.fromCounsellor}
                since={moment(mailThreadMessage.createdAt).fromNow()}
         avatarLetter={mailThreadMessage.sender.charAt(0)}
       avatarImageUrl={mailThreadMessage.avatar.url}
           authorName={mailThreadMessage.sender}
         animateHover={false}>
           <Linkify properties={{target: '_blank', style: {fontWeight: 'bold'}}}>{nl2br(emojify(mailThreadMessage.text, {output: 'unicode'}))}</Linkify>

    </Reply>
    );
};

MailThreadMessage.propTypes = {
  mailThreadMessage: MailThreadMessageShape
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch, props) => {
  return {
    onDidBecomeVisible: () => {
      if(props.mailThreadMessage.read && props.mailThreadMessage.fromCounsellor) {
        dispatch(actions.mailThreadMessageUpdate(props.threadId, props.mailThreadMessage.id, {read: true}));
      }
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MailThreadMessage);



/** WEBPACK FOOTER **
 ** ./src/members/Main/Mail/MailThreadMessagesList/MailThreadMessage/index.js
 **/